/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskWorkflowItemConfigurationTargetingOneOf
 */
export interface TaskWorkflowItemConfigurationTargetingOneOf {
    /**
     * 
     */
    target_type?: TaskWorkflowItemConfigurationTargetingOneOfTargetTypeEnum;
    /**
     * 
     */
    facility_ids?: Array<any>;
    /**
     * 
     */
    facility_system_tags?: Array<any>;
    /**
     * 
     */
    facility_custom_tag_ids?: Array<any>;
}


/**
 * @export
 */
export const TaskWorkflowItemConfigurationTargetingOneOfTargetTypeEnum = {
    All: 'ALL',
} as const;
export type TaskWorkflowItemConfigurationTargetingOneOfTargetTypeEnum = typeof TaskWorkflowItemConfigurationTargetingOneOfTargetTypeEnum[keyof typeof TaskWorkflowItemConfigurationTargetingOneOfTargetTypeEnum];


/**
 * Check if a given object implements the TaskWorkflowItemConfigurationTargetingOneOf interface.
 */
export function instanceOfTaskWorkflowItemConfigurationTargetingOneOf(value: object): value is TaskWorkflowItemConfigurationTargetingOneOf {
    return true;
}

export function TaskWorkflowItemConfigurationTargetingOneOfFromJSON(json: any): TaskWorkflowItemConfigurationTargetingOneOf {
    return TaskWorkflowItemConfigurationTargetingOneOfFromJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationTargetingOneOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskWorkflowItemConfigurationTargetingOneOf {
    if (json == null) {
        return json;
    }
    return {
        
        'target_type': json['target_type'] == null ? undefined : json['target_type'],
        'facility_ids': json['facility_ids'] == null ? undefined : json['facility_ids'],
        'facility_system_tags': json['facility_system_tags'] == null ? undefined : json['facility_system_tags'],
        'facility_custom_tag_ids': json['facility_custom_tag_ids'] == null ? undefined : json['facility_custom_tag_ids'],
    };
}

export function TaskWorkflowItemConfigurationTargetingOneOfToJSON(json: any): TaskWorkflowItemConfigurationTargetingOneOf {
    return TaskWorkflowItemConfigurationTargetingOneOfToJSONTyped(json, false);
}

export function TaskWorkflowItemConfigurationTargetingOneOfToJSONTyped(value?: TaskWorkflowItemConfigurationTargetingOneOf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target_type': value['target_type'],
        'facility_ids': value['facility_ids'],
        'facility_system_tags': value['facility_system_tags'],
        'facility_custom_tag_ids': value['facility_custom_tag_ids'],
    };
}

